export default "/react/logoBotica-30ecb77d.png";